<template>
	<BaseContenedor>
		<AgregarPregunta
			ref="exam"
			v-model="pregunta"
			:editar="editar"
			:loading="getLoadingAction"
			@guardar="onCrear"
			@editar="onEditar"
		></AgregarPregunta>
		<div class="ui one column grid">
			<div class="column">
				<div class="ui segment">
					<a class="ui blue ribbon label">Banco de preguntas</a>
					<BaseButton
						v-puede="[roles.Administrador]"
						style-button="primary"
						style-class="right floated"
						@click="toggleModal"
					>
						<i class="plus icon"></i>
						Agregar pregunta
					</BaseButton>
					<br />
					<br />
					<sui-accordion exclusive styled style="width:100%">
						<template
							v-for="(mpregunta, keyPregunta) in getBancoDePreguntas.preguntas"
						>
							<sui-accordion-title
								:key="`${keyPregunta}-item-pregunta`"
								:active="false"
								style="position:relative"
							>
								<button
									v-puede="[roles.Administrador]"
									class="ui compact icon basic button mini secondary right floated"
									title="Editar"
									style="position: absolute; top: 9px; right: 43px;"
									@click.stop
									@click.prevent="editarClick(mpregunta)"
								>
									<i class="edit outline icon"></i>
								</button>
								<button
									v-puede="[roles.Administrador]"
									class="ui compact icon basic button mini red right floated"
									title="Eliminar"
									style="position: absolute; top: 9px; right: 5px;"
									@click.stop
									@click.prevent="onEliminar(mpregunta)"
								>
									<i class="trash icon"></i>
								</button>
								<sui-icon
									v-show="mpregunta.respuestas.length > 0"
									name="dropdown"
									style="position: absolute; top: 14px; left: 0;"
								/>
								<label>
									<base-mostrar-markdown
										style="display: inline-block;width: 96% !important; color:black;"
										:agregado="`**${mpregunta.clave}.**`"
										:contenido="mpregunta.contenido"
									/>
								</label>
							</sui-accordion-title>
							<sui-accordion-content
								v-show="mpregunta.respuestas.length > 0"
								:key="
									`${keyPregunta}-item-pregunta-${keyPregunta}-content-banco`
								"
								:active="false"
							>
								<template
									v-for="(respuesta, keyRespuesta) in mpregunta.respuestas"
								>
									<div :key="`respuesta-${keyRespuesta}`" style="padding: 1em;">
										<div class="field">
											<div class="ui radio checkbox">
												<input
													:id="`pregunta-${keyPregunta}-${keyRespuesta}`"
													type="radio"
													:name="`pregunta_${keyPregunta}`"
													disabled
													:value="respuesta.opcion"
													:checked="
														respuesta.opcion === mpregunta.respuestaCorrecta
															? 'checked'
															: ''
													"
												/>
												<label
													:key="`respuesta-${keyRespuesta}`"
													:for="`pregunta_${keyRespuesta}`"
													style="color:black;cursor: pointer;"
												>
													<base-mostrar-markdown
														:agregado="`**${respuesta.opcion}** **)** `"
														:contenido="respuesta.contenido"
													/>
												</label>
											</div>
										</div>
									</div>
								</template>
							</sui-accordion-content>
						</template>
						<sui-accordion-title
							v-show="(getBancoDePreguntas.preguntas || []).length === 0"
							style="text-align:center;"
						>
							<b>
								Sin bancos de preguntas registrados
							</b>
						</sui-accordion-title>
					</sui-accordion>
				</div>
			</div>
		</div>
	</BaseContenedor>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import 'markdown-it-latex/dist/index.css';
import markdownIt from 'markdown-it';
import markdownItLatex from 'markdown-it-latex';
import Notification from '@utils/notification';
import AgregarPregunta from './agregar-pregunta.vue';
import Rols from '@constants/roles';
const mdi = markdownIt({
	html: true,
	linkify: false,
	typographer: true
});
mdi.use(markdownItLatex);

export default {
	components: { AgregarPregunta },
	page: {
		title: 'Detalle de banco de preguntas',
		meta: [
			{ name: 'Banco de preguntas', content: 'Detalle de banco de preguntas' }
		]
	},
	data: function() {
		return {
			pregunta: {},
			editar: false,
			openCrearAreaDeConocimiento: false,
			openCrearSeccion: false,
			claveArea: '',
			nombreArea: '',
			tiempoArea: '',
			tiempoDescansoArea: '',
			introduccionArea: '',
			claveSeccion: '',
			nombreSeccion: '',
			numeroPreguntasSeccion: '',
			erroresArea: false,
			erroresSeccion: false,
			configTime: {
				enableTime: true,
				noCalendar: true,
				dateFormat: 'H:i',
				time_24hr: true
			},
			roles: Rols
		};
	},
	computed: {
		...mapGetters('examenes', ['getExamen', 'getLoading']),
		...mapGetters('bancosDePreguntas', [
			'getBancoDePreguntas',
			'getLoading',
			'getLoadingAction'
		])
	},
	watch: {},
	mounted() {
		this.establecerTitulo('Detalle del banco de preguntas');
		this.establecerUrlAtras('/bancosDePreguntas');
		if (this.$route.params.clave !== undefined) {
			this.obtenerBancoDePreguntas({
				clave: this.$route.params.clave,
				onComplete: () => {}
			});
		}
	},
	methods: {
		...mapActions('app', ['establecerTitulo', 'establecerUrlAtras']),
		...mapActions('examenes', ['editarAreaSeccion']),
		...mapActions('bancosDePreguntas', [
			'obtenerBancoDePreguntas',
			'establecerPregunta',
			'crearPregunta',
			'editarPregunta',
			'eliminarPregunta'
		]),
		render(contenido) {
			return mdi.render(contenido);
		},
		renderRespuesta({ opcion, contenido }) {
			return mdi.render(contenido);
		},
		toggleModal() {
			this.editar = false;
			this.$refs.exam.toggle();
		},
		onCrear() {
			this.crearPregunta({
				clave: this.$route.params.clave,
				data: {
					clave: this.pregunta.clave,
					contenido: this.pregunta.contenido,
					respuestas: this.pregunta.respuestas,
					respuestaCorrecta: this.pregunta.respuestaCorrecta
				},
				onComplete: () => {
					this.$refs.exam.close();
					Notification('success', '¡Pregunta creada con éxito!');
					setTimeout(() => {
						this.obtenerBancoDePreguntas({
							clave: this.$route.params.clave,
							onComplete: () => {}
						});
					}, 2000);
				}
			});
		},
		editarClick(pregunta) {
			this.establecerPregunta(pregunta);
			this.editar = true;
			this.$refs.exam.toggle();
			setTimeout(() => {
				this.obtenerBancoDePreguntas({
					clave: this.$route.params.clave,
					onComplete: () => {}
				});
			}, 2000);
		},
		onEditar() {
			const exa = {
				contenido: this.pregunta.contenido,
				respuestas: this.pregunta.respuestas,
				respuestaCorrecta: this.pregunta.respuestaCorrecta
			};
			this.editarPregunta({
				clave: this.$route.params.clave,
				data: {
					...exa,
					clave: this.pregunta.clave
				},
				onComplete: () => {
					this.$refs.exam.close();
					Notification('success', '¡Pregunta modificada con éxito!');
					setTimeout(() => {
						this.obtenerBancoDePreguntas({
							clave: this.$route.params.clave,
							onComplete: () => {}
						});
					}, 2000);
				}
			});
		},
		onEliminar(item) {
			this.$confirm({
				title: 'Eliminar pregunta',
				message: '¿Desea eliminar la pregunta seleccionada?',
				description: 'Esta opción no se puede deshacer.',
				titleOk: 'Aceptar',
				titleCancel: `Cancelar`,
				callbackOk: (closeModal) => {
					this.eliminarPregunta({
						clave: this.$route.params.clave,
						data: {
							clave: item.clave,
							contenido: item.contenido,
							respuestas: item.respuestas,
							respuestaCorrecta: item.respuestaCorrecta
						},
						onComplete: () => {
							closeModal();
							Notification('success', '¡Pregunta eliminada con éxito!');
						},
						onError: () =>
							Notification('error', 'Error al eliminar la pregunta')
					});

					setTimeout(() => {
						this.obtenerBancoDePreguntas({
							clave: this.$route.params.clave,
							onComplete: () => {}
						});
					}, 2000);
				},
				callbackCancelar: () => {}
			});
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';
.danger {
	color: $background-danger;
}
</style>
